// Content for THE GAFFER — Burgers & Shakes, Albany WA

// ---------------------------------------------------------------------------
// Image CDN proxy — wraps source images through images.weserv.nl which
// auto-resizes and converts to WebP/AVIF on the fly. This is a free,
// well-known image proxy (used widely in production by indie projects).
// Result: 5.7 MB → ~250 KB. Critical for slow / mobile / regional networks.
// We do NOT proxy SVG, GIF, or logos — only photos with a known max width.
// ---------------------------------------------------------------------------
export function cdnImg(url, width = 1400, quality = 80) {
    if (!url || typeof url !== "string") return url;
    // Strip protocol since weserv.nl expects "host/path" form.
    const stripped = url.replace(/^https?:\/\//, "");
    return (
        `https://images.weserv.nl/?url=${encodeURIComponent(stripped)}` +
        `&w=${width}&q=${quality}&output=webp`
    );
}

export const ORDER_ONLINE_URL =
    "https://order.chewzie.me/thegafferburgersshakes/?c=eyJiZWFjb25TY2FuVGltZSI6IDE3Nzg0ODYxNzAxODUsICJzY2FuSWQiOiAiYzkyZWJlYmY1YzE5NDBmNmFjZjlhZWRmNTUzZmUwNzYiLCAic2NhblR5cGUiOiAicG9zdGVyIiwgImJlYWNvbklkIjogIjE5NGNlZmYzN2RhenBvIn0=";

// Uber Eats delivery link
export const DELIVERY_URL =
    "https://www.ubereats.com/store-browse-uuid/c483e7dd-c9d8-507d-9411-2418dd8e66ad?diningMode=DELIVERY";

export const FACEBOOK_URL =
    "https://www.facebook.com/profile.php?id=61563829387166";

// Original full wordmark logo (used in header/footer)
export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/deqs4l71_IMG_7443.jpeg";

// G monogram logo (used above hero text)
export const MONOGRAM_URL =
    "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/tqfbzd1v_image.png";

// Storefront photo (used on About page)
export const STOREFRONT_URL =
    "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/9xtxu929_IMG_7453.jpg";

// New hero burger photo (cleaner cutout)
export const HERO_IMAGE_URL =
    "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/39h4v93o_image.png";

// Full printed menu (photo of actual menu card — front side)
export const MENU_IMAGE_URL =
    "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/44tri26i_IMG_7448.jpeg";

// Back side of printed menu (shakes, soft drinks, coffee, kids meals)
export const MENU_IMAGE_BACK_URL =
    "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/o3qa6gpj_IMG_7449%20%282%29.jpeg";

// About page interior counter photo
export const ABOUT_INTERIOR_URL =
    "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/gbzej1u3_IMG_7760%20%281%29.jpeg";

// Google Maps directions
export const MAPS_URL =
    "https://www.google.com/maps/search/?api=1&query=The+Gaffer+190+York+St+Albany+WA";

// Home-page slow gallery
export const CAROUSEL_IMAGES = [
    {
        url: "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/yycs36uo_IMG_7451%20%281%29.jpeg",
        alt: "Loaded fries with bacon, cheese sauce and spring onion",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/h056h6uk_IMG_7458%20%281%29.jpg",
        alt: "Two Gaffer burgers with a basket of crinkle-cut chips",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/aw9itawo_IMG_7450.jpeg",
        alt: "Thick shake topped with waffle, pretzels and popcorn",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/uo1fdrkt_IMG_7457.jpg",
        alt: "Crispy panko-crumbed chicken tenders with sweet chilli dipping sauce",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/syhnf2j4_IMG_7454.jpeg",
        alt: "The Gaffer neon sign behind a beer and cocktail at the bar",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/zp24vg5b_IMG_7456.jpeg",
        alt: "Brioche burger with hash brown and runny fried egg",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/39h4v93o_image.png",
        alt: "The Gaffer signature smashed burgers lined up",
    },
];

export const BRAND = {
    name: "THE GAFFER",
    sub: "BURGERS & SHAKES",
    address: {
        street: "190 York Street",
        city: "Albany",
        region: "Western Australia",
    },
    hours: [
        { day: "Mon — Sat", hours: "11:00 — 20:00" },
        { day: "Sunday", hours: "Closed" },
    ],
    rating: { stars: 4.5, count: 168 },
};

export const ORDER_STEPS = [
    {
        n: "01",
        title: "Choose Pickup or Delivery",
        body: "Hit the pickup or delivery button below. Pickup uses our live Chewzie page, delivery goes through Uber Eats.",
    },
    {
        n: "02",
        title: "Build Your Meal",
        body: "Pick your burger, choose a side, add a thick shake. Customise sauces, extras and dietary preferences.",
    },
    {
        n: "03",
        title: "Pay & Enjoy",
        body: "Pay securely online — then collect from 190 York Street, or sit back and we’ll send it your way via Uber Eats.",
    },
];

export const REVIEWS = [
    {
        author: "Sarah H.",
        quote:
            "Booked a table for 7 on a busy Saturday. Staff friendly, meals out quickly. Best veg burger I’ve ever had.",
    },
    {
        author: "Samantha D.",
        quote:
            "Great food, good service. The hot honey chicken bites were delicious — going back for more.",
    },
    {
        author: "Ella W.",
        quote: "Super nice food — came out perfect and quickly. All five stars.",
    },
];
